import { Component, inject } from '@angular/core';
import { ViewportEnterDirective } from "../viewport-enter-directive";
import { ActiveRoute } from '../active-route';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-hero',
  standalone: true,
  imports: [ViewportEnterDirective,CommonModule,RouterModule],
  templateUrl: './hero.html',
  styleUrl: './hero.scss',
})
export class Hero {
   activeRoute= inject(ActiveRoute)
   fullVideo=false;
}
